<template>
    <div style="height: 100%">
        <RelatorioJustificativaNaoAtendimentoList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import RelatorioJustificativaNaoAtendimentoList from '@/components/promotor/relatorio-analitico/relatorio-justificativa-nao-atendimento/RelatorioJustificativaNaoAtendimentoList.vue';

export default {
    name: 'RelatorioJustificativaNaoAtendimentoListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-justificativa-nao-atendimento-list';
        if (from.name != 'relatorio-justificativa-nao-atendimento-list' && to.name == 'relatorio-justificativa-nao-atendimento-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        RelatorioJustificativaNaoAtendimentoList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-justificativa-nao-atendimento') &&
            this.$route.name != 'relatorio-justificativa-nao-atendimento-list';
    },
};
</script>
